import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FaqAccordion() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20" aria-labelledby="faq-title">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">FAQ</p>
          <h2
            id="faq-title"
            className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl"
          >
            常见问题
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于内容来源、更新节奏与阅读方式，这里集中回答最常被问到的问题。如果还有疑问，欢迎通过邮件联系我们。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200/80 overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
            {faqs.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div key={item.q}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : idx)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/70"
                    >
                      <span className="text-sm font-medium text-foreground-900 md:text-base">
                        {item.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-5 pb-5 -mt-1">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}